import { RegisterForm } from "../components/register-form";

export default function RegisterPage() {
  return (
    <div className="h-full flex flex-col gap-7 items-start justify-center">
      <div className="space-y-2">
        <h1 className="text-xl font-semibold">Create an account </h1>
        <h2 className="text-sm text-neutral-600">
          Enter your details to get started with our platform
        </h2>
      </div>
      <RegisterForm />
    </div>
  );
}
